module.exports = __webpack_public_path__ + "img/list_grey.0351aa75.svg";